import axios from 'axios';
import { toast } from 'sonner';

const KEY = 'pendingReferralCode';
const API = `${process.env.REACT_APP_BACKEND_URL}/api/referrals`;

export const savePendingReferral = (code) => {
  const clean = (code || '').trim().toUpperCase();
  if (/^[A-Z0-9]{4,16}$/.test(clean)) localStorage.setItem(KEY, clean);
};

export const getPendingReferral = () => localStorage.getItem(KEY);

// Runs once after sign-in; works for email and Google sign-ups alike
export const claimPendingReferral = async () => {
  const code = getPendingReferral();
  if (!code) return;
  try {
    const { data } = await axios.post(`${API}/claim`, { code }, { withCredentials: true });
    toast.success(data.message);
  } catch (error) {
    const detail = error.response?.data?.detail;
    if (error.response?.status !== 409 && typeof detail === 'string') toast.message(detail);
  } finally {
    localStorage.removeItem(KEY);
  }
};
